function copyToClipboard(text: string): Promise<string> {
  return new Promise((resolve, reject) => {
    if (navigator.clipboard && window.isSecureContext) {
      // Modern Clipboard API (works with HTTPS)
      navigator.clipboard
        .writeText(text)
        .then(() => {
          resolve('Text copied to clipboard');
        })
        .catch((err) => {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(`Failed to copy text: ${err}`);
        });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed'; // Prevents scrolling to bottom of page in some mobile browsers
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          resolve('Text copied to clipboard (fallback method)');
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('Fallback: Unable to copy');
        }
      } catch (err) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(`Fallback: Error trying to copy: ${err}`);
      }
      document.body.removeChild(textArea);
    }
  });
}
export default copyToClipboard;
